import { useMutation } from "@apollo/react-hooks";

import { VehicleAssignment } from "@hubcapp/graphql/types/gateway";
import updateInstructorMileage from "../graph-ql/updateInstructorMileage.graphql";

const useMutationUpdateMileage = ({
  onCompleted,
}: {
  onCompleted: (data: {
    vehicleAssignments?: Array<VehicleAssignment>;
  }) => void;
}) =>
  useMutation(updateInstructorMileage, {
    onCompleted,
  });

export default useMutationUpdateMileage;
